<div class="basic-container" [ngClass]="containerCss">
    <ng-content></ng-content>
</div>